import Component from 'vue-class-component';
import BaseComponent from '@/components/base/BaseComponent';

@Component({})
export default class FeedbackComponent extends BaseComponent {

  public beforeMount() {
    this.hasFeedback = true;
  }
}
